<template>
  <!-- Nav -->
  <nav class="navbar navbar-dark navbar-theme-primary px-4 col-12 d-lg-none">
    <a class="navbar-brand me-lg-5" href="/">
      <img
        class="navbar-brand-dark"
        src="assets/logo.png"
        alt="CGT Bilişim"
      />
      <img
        class="navbar-brand-light"
        src="assets/logo.png"
        alt="CGT Bilişim"
      />
    </a>
    <div class="d-flex align-items-center">
      
    </div>
  </nav>
  <!--/ End Nav -->
</template>

<script>
export default {
  name: "AppHeader",
};
</script>

<style lang="scss" scoped></style>
